import { useHookstate } from "@hookstate/core"
import { UPDATED_CAR_DATA_STATE, MAP_GLOBAL_STATES } from "globalStore/globalStore"
import { useEffect } from "react"
import { isCarInUse } from '../_helperFunctions/isCarInUse';
import { carType } from "constant";
import { isStale } from "_helperFunctions/isStale";
import { isValidLocation } from "_helperFunctions/isValidLocation";

export const useFilteredMapCarsHook = ({
  marshalCars,
  specialCars,
  memberCars,
  beverageCars,
  fleetCars,
  notInUseCars,
  notCommunicatingCars,
  outsidePerimeter
}) => {
  const { updatedCarData: updatedCarDataState } = useHookstate(UPDATED_CAR_DATA_STATE);
  const {
    getSelectedCarsMapState,
  } = useHookstate(MAP_GLOBAL_STATES)

  useEffect(() => {
    if (
      marshalCars ||
      specialCars ||
      memberCars  ||
      beverageCars ||
      fleetCars ||
      notCommunicatingCars ||
      notInUseCars
    ) {
      if (updatedCarDataState.get() && updatedCarDataState.get().length !== 0) {

        let allCars = JSON.parse(updatedCarDataState.get() && updatedCarDataState.get());

        let tempArray = [...allCars];
        let filterCategory = [notCommunicatingCars, notInUseCars, outsidePerimeter, fleetCars, marshalCars, specialCars, beverageCars,memberCars]

        filterCategory.map((item, i) => {
          if (!item) {
            if (i === 0)
              tempArray = tempArray.filter(item => !isStale(item.Car))

            if (i === 1)
              tempArray = tempArray.filter(item => isCarInUse(item.Car))

            if (i === 2)
              tempArray = tempArray.filter(item => !isValidLocation(item.Car.Latitude, item.Car.Longitude))

            if (i === 3)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.member)

            if (i === 4)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.marshal)

            if (i === 5)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.handicap)

            if (i === 6)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.bevcart)
            
            if (i === 7)
              tempArray = tempArray.filter(item => item.Car.CarType !== carType.member)
          }
        })

        getSelectedCarsMapState.set(tempArray)
      }
    } else {
      let carsData = updatedCarDataState && updatedCarDataState.get().length !== 0 ? JSON.parse(updatedCarDataState.get()) : []
      getSelectedCarsMapState.set([...carsData])
    }
  }, [
    marshalCars,
    specialCars,
    beverageCars,
    fleetCars,
    notInUseCars,
    notCommunicatingCars,
  ])

  return {
    getSelectedCarsMapState
  }

}